import type { CrumbObj, TFunction } from '@fides/fides-react-components';
import { getTitleFromStateName } from './getPageTitleFromStateName';

type WithRequiredProperty<Type, Key extends keyof Type> = Type & { [Property in Key]-?: Type[Property] };

type ReactCrumbPropsType = {
  crumbs?: CrumbObj[];
  isDetailView?: boolean;
  pageTitle?: string;
};

export const REACT_AH_CRUMBS_DETAIL_DATA_READY = 'react:ah:crumbsDetailDataReady';

export const REACT_AH_CRUMBS_CHANGED = 'react:ah:crumbsChanged';
export const setReactCrumbProps = async ($rootScope: any, reactCrumbProps: ReactCrumbPropsType = {}) => {
  const { crumbs = [], isDetailView = false, pageTitle } = reactCrumbProps;
  Promise.resolve(crumbs).then(crumbs => {
    $rootScope.reactCrumbProps = {
      crumbs,
      isDetailView,
      pageTitle,
    };
    $rootScope.$emit(REACT_AH_CRUMBS_CHANGED);
  });
};

export const getReactCrumbProps = ($rootScope: any, defaultTitle: string) => {
  const { crumbs = [], isDetailView = false, pageTitle = defaultTitle } = $rootScope.reactCrumbProps;
  const rc: WithRequiredProperty<ReactCrumbPropsType, 'crumbs' | 'isDetailView' | 'pageTitle'> = {
    crumbs,
    isDetailView,
    pageTitle
  };
  return rc;
};

export const REACT_AH_DATA_READY = 'react:ah:data-ready';
export const signalApplicationHeaderDataReady = ($rootScope: any) => {
  $rootScope.$emit(REACT_AH_DATA_READY);
};

const prepareReactCrumbPropsForState: (stateName: string, entity: any, t: TFunction) => [CrumbObj[], boolean, string] = (stateName, entity, t) => {
  const pageTitle = getTitleFromStateName(stateName);
  if (pageTitle !== null){
    return [[], false, pageTitle];
  }

  switch (stateName) {
    // AccountController
    case "app.accountDetail":
    case "app.accountDetailstatements":
    case "app.accountDetailintradays":
      return [
        entity ? [
          {
            label: 'NAVIGATION.BALANCES.LABEL',
            to: '/app/accounts',
          },
          {
            label: `${t('PAGE_TITLE.ACCOUNT')} ${entity.userDefinedAlias1}`
          },
        ] : [],
        true,
        'NAVIGATION.BALANCES.LABEL'
      ];
    // StatementController
    case 'app.statementDetail':
      return [
        entity ? [
          {
            label: 'NAVIGATION.REPORTINGS.STATEMENTS',
            to: '/app/statements',
          },
          {
            label: `${t('PAGE_TITLE.ACCOUNT')} ${entity.userDefinedAlias1}`
          },
        ] : [],
        true,
        'NAVIGATION.REPORTINGS.STATEMENTS'
      ];
    // IntradayDetailController
    case 'app.intradayDetail':
      return [
        entity ? [
          {
            label: 'NAVIGATION.REPORTINGS.INTRADAYS',
            to: '/app/intradays',
          },
          {
            label: `${t('PAGE_TITLE.ACCOUNT')} ${entity.userDefinedAlias1}`
          },

        ] : [],
        true,
        'NAVIGATION.REPORTINGS.STATEMENTS'
      ];
    default:
      console.error(stateName);
      return [[], false, stateName];
  }
}

export const resolveReactCrumbProps = (stateName: string, entity: unknown, t: TFunction) => {
  const [crumbs, isDetailView, pageTitle] = prepareReactCrumbPropsForState(stateName, entity, t);

  return {
    pageTitle,
    isDetailView,
    crumbs,
  }
}
